<template>
  <section>
      <v-data-table :headers="headers" :items="GetCourseDetails" class="elevation-1" style="margin:5px;">
        <template v-slot:headers="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"> {{ header.text }} </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">{{ props.item.Course_Title }}</td>
            <td class="text-xs-center">{{ props.item.Related_Courses ? props.item.Related_Courses.length : 0 }}</td>
            <td class="text-xs-center">
              <v-icon color="primary" icon class="btnAction" @click="EditRelatedCourse(props.item)">edit</v-icon>
              <v-icon color="primary" icon class="btnAction" @click="DeleteRelatedCourse(props.item)">delete</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <app-related-course ref="UpdateDetails" :dialog='Dialog' @close='CloseDialog'></app-related-course>
  </section>
</template>
<script>

  import appRelatedCourse from '../dialogs/AddRelatedCourse'

export default {
  components:{
      appRelatedCourse
  },
  data() {
    return {
      pagination: { sortBy: "Course_Title" },
      headers: [
        { text: "Course Title", value: "Course_Title" },
        { text: "Related Courses" },
        { text: "Actions" }
      ],
      UpdateSEO: false,
      Dialog   : false
    };
  },
  computed: {
    GetCourseDetails() {
        return this.$store.getters.GetCourseDetailsList;
    }
  },
  methods: {
    EditRelatedCourse(Course){
        this.$refs.UpdateDetails.UpdateRelatedCourse(Course)
        this.Dialog = true
    },
    DeleteRelatedCourse(Course){
      
         this.$http.post(`${this.$store.getters.GetProductionUrl}/course/deleterelatedcourse`,Course)
                .then(response =>{
                    
                    this.$store.commit('DeleteRelatedCourse',response['data']['response'])
                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Deleted Related Course","Color":"green","Close": false });

                })
                .catch(err =>{

                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Deleting Related Course","Color":"red","Close": false });
                })
    },
    CloseDialog(){
      this.Dialog = false
    }
  }
};
</script>
<style scoped>
.btnAction{
  margin: 4px;
  border: 1px solid #d3d3d37a;
}
</style>


